import axios from 'axios'

const api = axios.create({
    baseURL: 'https://gsehelp.com/api',
});

const DOWNLOADS_URL = 'https://pcswebsite.s3.us-east-1.amazonaws.com/gsehelp/downloads.json';
const DIAGNOSTIC_VERSION_URL = "https://www.powertraincontrolsolutions.com/download/Released/Public/CD-PCS_TCM_Diagnostics_Version.txt";

export async function getDownloadsByType(type) {
    try {
        const response = await fetch(DOWNLOADS_URL);

        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }

        const data = await response.json();

        return data?.[type] ?? [];
    } catch (error) {
        console.error("Failed to load downloads.json from S3", {
            url: DOWNLOADS_URL,
            message: error.message,
        });

        return [];
    }
}
              

export async function getTCMDiagnosticVersion(){
    try {
        const response = await fetch(DIAGNOSTIC_VERSION_URL);
        if (response.ok) {
            const text = await response.text();
            return text;
        } else {
            console.error("Failed to fetch version file");
        }
    } catch (error) {
        console.error("Failed to load diagnostic version", {
            url: DIAGNOSTIC_VERSION_URL,
            message: error.message,
        });

        return "N/A";
    }
}

export default api;

